export default class Anchor {
    static init(): void {
        this.baseAnchorInit();
    }

    static baseAnchorInit(): void {
        function initSmoothScroll(): void {
            const anchorElements = document.querySelectorAll('[data-anchor]');

            if (anchorElements.length === 0) {
                return;
            }

            anchorElements.forEach((element: Element) => {
                element.addEventListener('click', (e: Event) => {
                    e.preventDefault();

                    const target = e.currentTarget as HTMLElement;
                    const targetId = target.getAttribute('data-anchor');

                    if (targetId) {
                        const targetElement = document.getElementById(targetId);

                        if (targetElement) {
                            targetElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            });
                        }
                    }
                });
            });
        }

        initSmoothScroll();
    }
}
